import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Box, Chip } from '@rossum/ui/material';
import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GridColDef,
  GridValidRowModel,
} from '@rossum/ui/x-data-grid-pro';
import { totalCountAggregationColumnField } from '../../../constants';
import { DataForBulkEditDrawer } from '../../enum-formula-editing/EditColumnDrawer';

export const AggregationRenderCell = (
  props: Parameters<
    NonNullable<
      GridColDef<
        GridValidRowModel & {
          meta: {
            setDataForBulkEditDrawer: (data: DataForBulkEditDrawer) => void;
          };
        }
      >['renderCell']
    >
  >[0]
) => {
  const intl = useIntl();
  const { field } = props.colDef;
  const aggregationValue = props.value;
  const setDrawerState = props.row.meta.setDataForBulkEditDrawer;
  const onClick = useCallback(
    (fieldType: 'options' | 'formula') => {
      setDrawerState({
        field: fieldType,
        aggregations: aggregationValue,
      });
    },
    [setDrawerState, aggregationValue]
  );

  if (field === GRID_CHECKBOX_SELECTION_FIELD || field === 'actions') {
    return null;
  }
  if (field === totalCountAggregationColumnField) {
    return (
      <Box>
        {`${intl.formatMessage({
          id: 'features.fieldManager.fieldDetail.aggregations.formatAggregate.total',
        })} ${[...aggregationValue][0]}`}
      </Box>
    );
  }

  const fieldIsFormulaOrEnum = field === 'options' || field === 'formula';
  return aggregationValue && aggregationValue.size > 1 ? (
    <Chip
      label={intl.formatMessage(
        {
          id: 'features.fieldManager.fieldDetail.aggregations.formatAggregate.variants.label',
        },
        { count: aggregationValue.size }
      )}
      color={fieldIsFormulaOrEnum ? 'info' : 'default'}
      onClick={fieldIsFormulaOrEnum ? () => onClick(field) : undefined}
    />
  ) : (
    <Chip
      label={intl.formatMessage({
        id: 'features.fieldManager.fieldDetail.aggregations.formatAggregate.same.label',
      })}
      color="success"
    />
  );
};
